export default __webpack_public_path__ + "static/media/ch_1.df909861.mp3";